import type { TradeInAemContactFormReducerType } from "../reducers/TradeInAemContactFormReducer";
import type { TradeInAemContactCheckboxIdType, TradeInAemContactTextIdType } from "../../utils/constants";

export const TRADE_IN_AEM_CONTACT_FORM_INIT = "tradeInAemContact/init";
type TradeInAemContactInit = {
    type: typeof TRADE_IN_AEM_CONTACT_FORM_INIT;
    initState: TradeInAemContactFormReducerType;
};
export const initContactForm = (initState: TradeInAemContactFormReducerType): TradeInAemContactInit => ({
    type: TRADE_IN_AEM_CONTACT_FORM_INIT,
    initState,
});

export const TRADE_IN_AEM_CONTACT_SET_TEXT_ITEM = "tradeInAemContact/setTextItem";
type TradeInAemContactSetTextItem = {
    type: typeof TRADE_IN_AEM_CONTACT_SET_TEXT_ITEM;
    formItemId: TradeInAemContactTextIdType;
    value: string;
};
export const setTradeInAemContactTextValue = (
    formItemId: TradeInAemContactTextIdType,
    value: string,
): TradeInAemContactSetTextItem => ({
    type: TRADE_IN_AEM_CONTACT_SET_TEXT_ITEM,
    formItemId,
    value,
});

export const TRADE_IN_AEM_CONTACT_SET_CHECKBOX_ITEM = "tradeInAemContact/setCheckboxItem";
type TradeInAemContactSetCheckboxItem = {
    type: typeof TRADE_IN_AEM_CONTACT_SET_CHECKBOX_ITEM;
    formItemId: TradeInAemContactCheckboxIdType;
    value: string;
    selected: boolean;
};
export const setTradeInAemCheckboxValue = (
    formItemId: TradeInAemContactCheckboxIdType,
    value: string,
    selected: boolean,
): TradeInAemContactSetCheckboxItem => ({
    type: TRADE_IN_AEM_CONTACT_SET_CHECKBOX_ITEM,
    value,
    selected,
    formItemId,
});

export type TradeInAemContactFormActions =
    | TradeInAemContactInit
    | TradeInAemContactSetTextItem
    | TradeInAemContactSetCheckboxItem;
